import React from 'react';

const privacyPolicyConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/privacy-policy',
			component: React.lazy(() => import('./privacy-policy'))
		},
	]
};

export default privacyPolicyConfig;